/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpLogger from '@module-logger/mbp';
// import axios from 'axios';
import restClient from '../../../app/helpers/restClient';
import { parseBannerCodes } from '../../../app/components/MultiBrandChatController/utils/commonUtils';
import { getGuestUserAccessToken } from '../../../state/ducks/Member/ducks/Auth/Plugin/auth/guest';

const formatRequestBody = (payload, popOpenChatDetail, isCSPEnabled, isCSPV2Enabled) => {
    const returnValue = {
        formattedPayload: {
            ...payload,
            bannerCodes: parseBannerCodes(payload.bannerCodes)?.bannerCodes,
            popOpenChatDetail,
        },
        route: 'conversational/garden-webchat-api/webchat/conversation-id',
    };
    if (isCSPEnabled && isCSPV2Enabled) {
        // NOTE: CSP V_2 REGION
        returnValue.route = 'csp/webchat/v2/conversation/start';
        returnValue.formattedPayload = {
            bannerCodes: payload.bannerCodes,
            brand: payload.brand,
            browserInfo: payload.browserInfo,
            channel: 'WEBCHAT',
            customerData: {
                enterprise_id: payload.enterpriseId,
                contact_id: payload.contactId,
                email: payload.email,
                firstName: payload.firstName,
                lastName: payload.lastName,
                useCase: payload.useCase,
                origin: popOpenChatDetail.intent,
                passport: {
                    membershipType: payload.membershipType,
                    ...(payload.passportEndDate ? { endDate: payload.passportEndDate } : {}),
                    ...(payload.loyaltyStatus ? { tier: payload.loyaltyStatus } : {}),
                },
            },
        };
    } else if (isCSPEnabled && !isCSPV2Enabled) {
        // NOTE: CSP V_1 REGION
        returnValue.route = 'csp/webchat/conversation-id';
        returnValue.formattedPayload = {
            ...payload,
            bannerCodes: parseBannerCodes(payload.bannerCodes)?.bannerCodes,
            popOpenChatDetail,
        };
    }
    return returnValue;
};

export const getConvId = async (jwt, payload = {}, featureFlags, popOpenChatDetail = {}, setErrorState) => {
    try {
        const freshToken = await getGuestUserAccessToken() || jwt;
        const { route, formattedPayload } = formatRequestBody(payload, popOpenChatDetail, featureFlags['is-csp-chat-widget-enabled'], featureFlags['is-csp-v2-standard-enabled']);

        const response = await restClient.postFacade({ rootUri: '/' }, route, freshToken, formattedPayload);
        delete response.headers;
        delete response.request;
        delete response.config;

        // * Local testing region:
        // const response = await axios.post('http://localhost:8080/webchat/conversation-id', formattedPayload);

        return response;
    } catch (error) {
        setErrorState({ error: true, errorMessage: 'Failed to connect. Please exit chat and try again.' });
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            errorMessage: error,
            message: `WebChat: Could not get conversation id - ERROR: ${error}`,
        });
        return false;
    }
};

export default {};
